import { createContext } from "react";
import { User } from "firebase/auth";

export interface AuthContextType {
    user: User | null;
    loading: boolean;
    idToken: string | null;
    logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
    user: null,
    loading: true,
    idToken: null,
    logout: async () => { },
});
